import EventBus from "~event-bus"
import Vue from "vue"

import axios from "~axios"

import PaymentPage from "./layout/PaymentPage"
import PaymentSuccess from "@components/PaymentsModals/PaymentSuccess"

Vue.mixin({
    methods: {
        deleteMediaFiles(idsArray) {
            let data = {
                files: idsArray
            }
            let storageUrl = window.file_storage_url.replace("upload", "")
            axios.delete(`${storageUrl}delete-files/`, { params: data }).then(() => {})
        }
    }
})

// old function

axios
    .get(window.cached_routes["translation-groups"], {
        params: {
            groups: "course,common,create-course,payments,auth",
            lang: window.app_current_locale
        },
        headers: { "X-Language": window.app_current_locale }
    })
    .then(response => {
        window.langs = response.data
    })

const playlist = document.getElementById("playlist")
const openListBtn = document.getElementById("open-p-list")

;(function () {
    if (openListBtn) {
        openListBtn.addEventListener("click", function () {
            playlist.classList.toggle("active")
        })
    }
})()

document.addEventListener("DOMContentLoaded", function () {
    let init_btns = document.querySelectorAll("[data-modal-show]")
    for (let i = 0; i < init_btns.length; i++) {
        init_btns[i].addEventListener("click", function () {
            let modal_name = this.getAttribute("data-modal-show")
            showModal(modal_name)
        })
    }
})

let closeModalBtn = document.querySelectorAll(".js-close")
if (closeModalBtn) {
    Array.from(closeModalBtn).forEach(btn => {
        btn.addEventListener("click", function () {
            let target = btn
            while (!target.classList.contains("modal-subscribe")) {
                target = target.parentNode
            }
            target.classList.remove("modal-subscribe_visible")
            target.style.visibility = "hidden"
            EventBus.$emit("js-close", true)
        })
    })
}

function showModal(modal_name) {
    let visible_modal = document.querySelector(".visible[data-modal]")
    if (visible_modal) {
        visible_modal.classList.remove("modal-subscribe_visible")
        visible_modal.style.visibility = "hidden"
    }

    let modal = document.querySelector("[data-modal=" + modal_name + "]")
    if (modal) {
        modal.classList.add("modal-subscribe_visible")
        modal.style.visibility = "visible"
    }
}

if (document.getElementById("payment-page")) {
    new Vue({
        el: "#payment-page",
        components: {
            PaymentPage
        }
    })
}

if (document.getElementById("payment-success")) {
    new Vue({
        el: "#payment-success",
        components: {
            PaymentSuccess
        }
    })
}
